import * as THREE from 'three';

/**
 * FloorPlane - Invisible plane for raycasting click-to-move navigation
 */
export class FloorPlane {
  constructor(width = 100, height = 100, yPosition = 0) {
    // Create plane geometry
    const geometry = new THREE.PlaneGeometry(width, height);
    
    // Invisible material (for raycasting only)
    const material = new THREE.MeshBasicMaterial({
      visible: false,
      side: THREE.DoubleSide
    });
    
    this.mesh = new THREE.Mesh(geometry, material);
    
    // Rotate to be horizontal (XZ plane)
    this.mesh.rotation.x = -Math.PI / 2;
    this.mesh.position.y = yPosition;
    
    // Name for identification
    this.mesh.name = 'floor-plane';
    
    // Enable raycasting
    this.mesh.raycast = THREE.Mesh.prototype.raycast;
  }

  setPosition(y) {
    this.mesh.position.y = y;
  }

  setSize(width, height) {
    this.mesh.geometry.dispose();
    this.mesh.geometry = new THREE.PlaneGeometry(width, height);
  }

  dispose() {
    this.mesh.geometry.dispose();
    this.mesh.material.dispose();
  }
}
